export enum CategorySearchType {
  None = 'None',
  Products = 'Items',
  Customers = 'Customers',
  Transactions = 'Transactions',
}
